<template>
	<div>
		<!-- Navigation -->
		<section class="mt-n4 mb-1 pb-5">
			<p class="pull-right mb-2 small">
				<button
					:class="blockBtn == false ? '' : 'bg-neutral-300'"
					class="btn btn-primary px-2 py-2 pt-0 pb-1"
					style="font-size: 1rem; font-weight: bold"
					@click="goToNextStep"
					:disabled="processingApi || $v.$invalid"
				>
					<small> {{ $t("advance") }} </small>
				</button>
			</p>
			<p class="pull-right mr-2">
				<button
					class="btn btn-primary px-2 py-2 pt-0 pb-1"
					style="font-size: 1rem"
					@click="prevStepAndcleanForm()"
					:disabled="processingApi"
					v-show="activeStepIndex > 0"
				>
					<small> {{ $t("back") }} </small>
				</button>
			</p>
		</section>

		<!-- Form -->
		<div class="form-group">
			<label
				:class="survey.id == 552 ? 'color-avai' : 'black'"
				class="title-bold"
				for="cep"
			>
				{{ $t("form_address") }}
			</label>

			<!-- errors -->
			<div class="error mt-n2" v-if="$v.cep.$error">
				<span class="error" v-if="!$v.cep.required">{{
					$t("zip_code") + $t("is_required")
				}}</span>
			</div>

			<!-- ZIP Code -->
			<div v-if="isBrazil">
				<label
					:class="survey.id == 552 ? 'color-avai' : 'black'"
					class="title-bold"
					for="cep"
				>
					{{ $t("enter_your_cep") }}
				</label>
				<input
					type="text"
					class="form-control"
					:class="[
						profile.Address.Zip.length === 0 ? 'endereco-empty' : '',
						errorClass,
					]"
					id="cep"
					placeholder="00000-000"
					v-model="cep"
					:disabled="processingApi"
					@focusin="cleanMockupCep"
					@keyup="enterCep"
					@blur="setTouchedAndMockupCep"
					v-mask="'#####-###'"
				/>
			</div>

			<div v-else>
				<input
					type="text"
					class="form-control"
					:class="[
						profile.Address.Zip.length === 0 ? 'endereco-empty' : '',
						errorClass,
					]"
					id="zip"
					:placeholder="$t('enter_zip_code')"
					v-model="profile.Address.Zip"
				/>
			</div>

			<!-- Street -->
			<div>
				<input
					ref="logradouro"
					class="form-control endereco"
					:class="[
						profile.Address.Add1.length === 0 ? 'endereco-empty' : '',
						errorClass,
					]"
					:disabled="processingApi"
					:placeholder="$t('form_address_street')"
					v-model="profile.Address.Add1"
					type="text"
				/>

				<!-- Number -->
				<div class="d-flex">
					<input
						ref="numero"
						class="form-control endereco small-input mr-3"
						:class="[
							profile.Address.Number.length === 0 ? 'endereco-empty' : '',
							errorClass,
						]"
						:disabled="processingApi"
						required
						:placeholder="$t('form_address_number')"
						v-model="profile.Address.Number"
						type="text"
					/>

					<!-- Complement -->
					<input
						ref="complemento"
						class="form-control endereco"
						:class="[
							profile.Address.Add3.length === 0 ? 'endereco-empty' : '',
							errorClass,
						]"
						:disabled="processingApi"
						:placeholder="$t('form_address_complement')"
						v-model="profile.Address.Add3"
						type="text"
					/>
				</div>

				<!-- Neighborhood -->
				<input
					v-if="isBrazil"
					ref="bairro"
					class="form-control endereco"
					:class="[
						profile.Address.Add2.length === 0 ? 'endereco-empty' : '',
						errorClass,
					]"
					:disabled="processingApi"
					placeholder="Bairro"
					v-model="profile.Address.Add2"
					type="text"
				/>
				<div class="d-flex">
					<!-- City -->
					<input
						:disabled="isBrazil"
						ref="cidade"
						class="form-control endereco"
						:class="[
							profile.Address.City.length === 0 ? 'endereco-empty' : '',
							errorClass,
						]"
						:placeholder="$t('form_address_city')"
						v-model="profile.Address.City"
						type="text"
					/>

					<!-- State -->
					<input
						:disabled="isBrazil"
						ref="uf"
						class="form-control endereco small-input ml-3"
						:class="[
							profile.Address.State.length === 0 ? 'endereco-empty' : '',
							errorClass,
						]"
						:placeholder="isBrazil ? 'UF*' : $t('form_address_state')"
						v-model="profile.Address.State"
						type="text"
					/>
				</div>
			</div>
		</div>

		<!-- Button -->
		<div v-if="processingApi" class="div-start-survey">
			<h2
				class="title-bold"
				v-text="message"
				style="
          font-size: 0.95rem;
          letter-spacing: 0.35px;
          margin-bottom: -10px;
          text-transform: uppercase;
          text-align: center;
          color: black;
        "
			></h2>

			<h5
				class="loading"
				style="
          font-size: 1.25rem;
          letter-spacing: 0.35px;
          text-transform: uppercase;
          text-align: center;
          color: black;
        "
			>
				<span
					style="
            font-size: 1.25rem;
            letter-spacing: 0.35px;
            text-transform: uppercase;
            text-align: center;
            color: black;
          "
					class="dot"
					>.</span
				>
				<span
					style="
            font-size: 1.25rem;
            letter-spacing: 0.35px;
            text-transform: uppercase;
            text-align: center;
            color: black;
          "
					class="dot"
					>.</span
				>
				<span
					style="
            font-size: 1.25rem;
            letter-spacing: 0.35px;
            text-transform: uppercase;
            text-align: center;
            color: black;
          "
					class="dot"
					>.</span
				>
			</h5>
		</div>

		<section v-if="!processingApi" class="row">
			<div class="col-12 mt-5 mx-auto col-md-6">
				<button
					:style="
						style.surveyBtnColor
							? { backgroundColor: style.surveyBtnColor }
							: { backgroundColor: style.homeBtnColor }
					"
					type="submit"
					class="w-100 btn btn-primary btn-block my-3"
					@click="goToNextStep"
					:disabled="processingApi || $v.$invalid"
				>
					{{ $t("advance") }}
					<span
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
						v-if="processingApi"
					></span>
				</button>
			</div>
		</section>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
import Navigation from "@/components/registration/components/Navigation";

// Utils
import { utils } from "../../services/Survey.js";
const U = new utils();

import { mask } from "vue-the-mask";

export default {
	name: "SurveyAdress",
	components: {
		Navigation,
	},
	props: {
		profile: {
			type: Object,
			required: true,
		},
		processingApi: {
			type: Boolean,
			required: true,
		},
		activeStepIndex: {
			type: Number,
			required: true,
		},
	},
	data: () => ({
		showEnd: false,
		cep: "",
		completeForm: false,
		message: "",
	}),
	directives: {
		mask,
	},
	validations: {
		cep: required,
	},
	computed: {
		style() {
			return this.$store.state.template.style;
		},
		survey() {
			return this.$store.state.template.survey;
		},
		isBrazil() {
			return this.profile.Address.Country === 31;
		},
	},
	created() {
		this.message = this.$t("finishing_registration");
	},
	mounted() {
		this.checkConfigToCompleteForm();
		if (this.profile.Address.Zip) this.cep = this.profile.Address.Zip;
		if (this.activeStepIndex !== 0) this.focusOn("cep");
	},
	methods: {
		...mapActions(["clearSavedFields"]),
		focusOn(el) {
			document.getElementById(el).focus();
		},
		changeText() {
			setTimeout(() => {
				this.hidden = true;
				setTimeout(() => {
					this.message = this.$t("starting_search");
					this.hidden = false;
				}, 500);
			}, 2000);
		},
		goToNextStep() {
			if (this.validateAddress()) {
				this.$emit("next");
				this.clearSavedFields()
			} else {
				this.$vs.notify({
					color: "RGBA(255,0,0)",
					title: this.$t("invalid_address"),
					text: "",
					time: 5000,
				});
			}
		},
		checkConfigToCompleteForm() {
			if (this.config && this.config.includes("completeAddressForm"))
				this.completeForm = true;
		},
		cleanMockupCep() {
			if (this.cep === "00000-000") this.cep = "";
		},
		setTouchedAndMockupCep() {
			this.$v.cep.$touch();
			if (this.cep === "") {
				this.cep = "00000-000";
				// this.$vs.notify({
				//   color: "RGBA(255,0,0)",
				//   title: `Endereço informado inválido`,
				//   text: "",
				//   time: 5000
				// });
			}
		},
		emitNext(cep) {
			if (cep != "00000-000" && cep.length > 7) {
				this.$emit("next");
			} else {
				this.$vs.notify({
					color: "RGBA(255,0,0)",
					title: this.$t("invalid_address"),
					text: "",
					time: 5000,
				});
			}
		},
		enterCep(event) {
			if (
				event.key === "Enter" ||
				event.key === "Control" ||
				event.key === "Meta"
			) {
				event.preventDefault;
			} else if (this.cep.length === 9) {
				if (this.processingApi) {
					return false;
				}
				if (this.cep == "00000-000") {
					this.$vs.notify({
						color: "RGBA(255,0,0)",
						title: this.$t("invalid_address"),
						text: "",
						time: 5000,
					});
				} else {
					U.getCep(this.cep.replace("-", "")).then(
						(datacep) => {
							this.changeText();
							if (datacep.erro) {
								this.cep = "";
								this.$vs.notify({
									color: "RGBA(255,0,0)",
									title: this.$t("invalid_address"),
									text: "",
									time: 5000,
								});
							} else {
								this.showEnd = true;
								if (datacep.complemento)
									this.profile.Address.Add1 =
										datacep.logradouro + "(" + datacep.complemento + ")";
								else this.profile.Address.Add1 = datacep.logradouro;

								(this.profile.Address.Add2 = datacep.bairro),
									(this.profile.Address.City = datacep.localidade);
								this.profile.Address.State = datacep.uf;
								this.profile.Address.Zip = this.cep;
							}
						},
						(err) => {
							alert(err);
						}
					);
				}
			}
		},
		prevStepAndcleanForm() {
			this.profile.Address.Add1 = "";
			this.profile.Address.Add2 = "";
			this.profile.Address.Add3 = "";
			this.profile.Address.City = "";
			this.profile.Address.Number = "";
			this.profile.Address.State = "";
			this.profile.Address.Zip = "";
			this.cep = "";
			this.$emit("prev");
		},
		validateAddress() {
			const address = this.profile.Address;
			return (
				address.Add1 &&
				address.City &&
				address.Number &&
				address.State &&
				(!this.isBrazil || address.Add2)
			);
		},
	},
};
</script>

<style scoped>
.div-start-survey {
	margin-bottom: -15px;
	width: 100%;
	height: 70px;
	margin-top: 20px;
}

.loading {
	font-size: 1.25rem;
	letter-spacing: 0.35px;
	text-transform: uppercase;
	text-align: center;
	color: black;
}

.dot {
	animation: loading 1s infinite steps(1, end);
}

.dot:nth-child(2) {
	animation-delay: 0.2s;
}

.dot:nth-child(3) {
	animation-delay: 0.4s;
}

@keyframes loading {
	0% {
		opacity: 0;
	}

	50% {
		opacity: 1;
	}

	100% {
		opacity: 0;
	}
}

.small-input {
	width: 120px;
}

.small-input-2 {
	width: 160px;
}
</style>
